export enum GemstoneRole {
  GEM_TRADER = 'Gem Trader',
  DESIGNER = 'Designer',
  CUTTER = 'Cutter',
  ACADEMICIAN = 'Academician',
  GEMOLOGIST = 'Gemologist',
  MINER = 'Miner',
  RETAILER_BRAND = 'Retailer/Brand',
  OTHER = 'Other',
}
